import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertCircle, Timer } from "lucide-react";

/**
 * Shows a strip at the top of authenticated pages when the user's 48h trial
 * is active or has expired. Only rendered for photographers on starter/free plan.
 */
export default function TrialBanner() {
  const { user } = useAuth();
  const [t, setT] = useState(null);
  useEffect(() => {
    if (!user) return;
    api.get("/me/trial").then(r => setT(r.data)).catch(()=>{});
  }, [user?.user_id]);
  if (!user || !t) return null;
  if (user.role === "admin") return null;  // admins bypass every plan/trial gate
  if (!["starter", "free"].includes(t.plan)) return null;
  if (t.subscription_status === "active" || t.subscription_status === "trialing") return null;

  const expired = t.needs_subscription;
  const hours = Math.max(0, Math.floor(t.hours_left || 0));
  const mins = Math.max(0, Math.floor(((t.hours_left || 0) - hours) * 60));

  return (
    <div data-testid="trial-banner" className={`px-4 py-2 text-xs flex items-center gap-2 justify-center ${expired?"bg-red-500/15 text-red-200 border-b border-red-500/30":"bg-amber-500/10 text-amber-200 border-b border-amber-500/20"}`}>
      {expired ? (
        <>
          <AlertCircle className="w-3.5 h-3.5"/>
          <span>Your 48-hour Starter trial has ended.</span>
          <Link to="/pricing" data-testid="btn-trial-upgrade" className="ml-1 underline underline-offset-2 hover:text-white">Subscribe for $5.99/mo</Link>
        </>
      ) : (
        <>
          <Timer className="w-3.5 h-3.5"/>
          <span>Starter trial · <strong className="tabular-nums">{hours}h {mins}m</strong> left · <Link to="/pricing" data-testid="btn-trial-upgrade" className="underline underline-offset-2 hover:text-white">Subscribe</Link> to keep everything after</span>
        </>
      )}
    </div>
  );
}
